require('angular').module('wowApp.shop')
    .directive('savingsBadge', [require('./savings-badge-directive')])
    .directive('superSaversBadge', [require('./super-savers-badge-directive')])
    .directive('percentageOffBadge', [require('./percentage-off-badge-directive')])
    .directive('badge', [require('./badge-directive')])
    .service('BadgeService', [require('./badge-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/badges/index.js
 **/